if (!customElements.get("carousel-arrows")) {
	customElements.define(
		"carousel-arrows",
		class CarouselArrows extends HTMLElement {
			// Slide shown on hover (Image 2); mouse leave always goes back to Image 1
			static HOVER_INDEX = 1;

			connectedCallback() {
				this.init();
			}

			disconnectedCallback() {
				this.cleanup?.();
			}

			init() {
				const el = this.closest(".card-product__container")?.querySelector(
					".card-product__images",
				);
				if (!el) return;

				this.target = el;
				this.count = el.querySelectorAll("img").length;
				if (this.count < 2) return;

				this.prev = this.querySelector(".carousel-arrow--prev");
				this.next = this.querySelector(".carousel-arrow--next");

				const onPrev = () => this.slide(-1);
				const onNext = () => this.slide(1);
				this.prev?.addEventListener("click", onPrev);
				this.next?.addEventListener("click", onNext);

				// Hover (mouse only): show Image 2, then back to Image 1 on leave
				const card = this.closest(".card-product") || el;
				const onEnter = (event) => {
					if (event.pointerType !== "mouse") return;
					this.goTo(CarouselArrows.HOVER_INDEX);
				};
				const onLeave = (event) => {
					if (event.pointerType !== "mouse") return;
					this.goTo(0);
				};
				card.addEventListener("pointerenter", onEnter);
				card.addEventListener("pointerleave", onLeave);

				this.cleanup = () => {
					this.prev?.removeEventListener("click", onPrev);
					this.next?.removeEventListener("click", onNext);
					card.removeEventListener("pointerenter", onEnter);
					card.removeEventListener("pointerleave", onLeave);
				};
			}

			get current() {
				const { scrollLeft, clientWidth } = this.target;
				return clientWidth ? Math.round(scrollLeft / clientWidth) : 0;
			}

			slide(direction) {
				// Loops back to the first / last image by scrolling through the others
				const index = (this.current + direction + this.count) % this.count;
				this.goTo(index);
			}

			goTo(index) {
				const el = this.target;
				// No "already there" check: during a smooth scroll the current index is
				// stale, and skipping would let the previous scroll finish on the wrong image
				if (!el) return;
				el.scrollTo({ left: el.clientWidth * index, behavior: "smooth" });
			}
		},
	);
}
